/* eslint-disable operator-linebreak */
import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { getTimeDiffText, isEmpty } from '../../helpers';
import {
  diffDaysToColor,
  diffDaysToTooltipText,
  diffDaysToShowIcon,
} from '../../constants';
import { FINISHED_STATUS } from '../../constants/invoices';
import { AlertButton } from '../buttons';
import dayjs from '../../config/dayjs';

const DateWithDaysDiffCell = ({ date, useColors, status, useIcon }) => {
  const diffText = FINISHED_STATUS.includes(status)
    ? 'Recaudada'
    : getTimeDiffText(dayjs(date));
  const textColor =
    useColors && !FINISHED_STATUS.includes(status)
      ? diffDaysToColor(dayjs(date))
      : '';
  const tooltipText = diffDaysToTooltipText(dayjs(date));
  const showIcon = FINISHED_STATUS.includes(status)
    ? false
    : diffDaysToShowIcon(dayjs(date));

  return (
    <Grid
      container
      alignItems="left"
      justifyContent="flex-start"
      overflow="hidden"
      direction="row"
      spacing={1}
    >
      {!isEmpty(date) && dayjs(date).isValid() ? (
        <>
          {showIcon && useIcon && (
            <Grid item>
              <AlertButton
                id="alert-to-expire-cession-status"
                tooltipText={tooltipText}
                tooltipPlacement="left"
                color={textColor}
              />
            </Grid>
          )}
          <Grid item>
            <Typography variant="body1" sx={{ color: textColor }}>
              {dayjs(date).format('DD-MM-YYYY')}
            </Typography>
            <Typography variant="caption" sx={{ color: textColor }}>
              {diffText}
            </Typography>
          </Grid>
        </>
      ) : (
        <Grid item>
          <Typography variant="body1">Sin fecha</Typography>
        </Grid>
      )}
    </Grid>
  );
};

DateWithDaysDiffCell.propTypes = {
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(dayjs)]),
  useColors: PropTypes.bool,
  status: PropTypes.string,
  useIcon: PropTypes.bool,
};

DateWithDaysDiffCell.defaultProps = {
  useColors: false,
  status: '',
  date: null,
  useIcon: true,
};

export default DateWithDaysDiffCell;
